// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AbqR","colBig":"styles_colBig__2mj_9","colSmall":"styles_colSmall__2Zg9I"};